'use strict';

// eslint-disable-next-line max-len, max-lines-per-function, max-params
angular.module('webAgro1App').controller('ArredondamentoDosePorTanqueCtrl', function($uibModalInstance, recomendacao, DecimalsService) {
  this.recomendacao = { ...recomendacao };
  this.abastecidas = 0;
  this.showDoseTable = false;

  const toNumber = DecimalsService.toNumber;
  const toCapacidadeTanqueNumber = DecimalsService.toNumberWithThousands;
  const formatForInput = DecimalsService.formatForInput;

  function getAreaFixed(area) {
    return DecimalsService.isDecimalV2Enabled() ? DecimalsService.truncateArea(area) : +area.toFixed(2);
  }

  function getDoseByTanque(dose, area) {
    if (DecimalsService.isDecimalV2Enabled()) {
      const doseCalculated = DecimalsService.roundForCalculation(
        dose * area,
        DecimalsService.DECIMAL_PLACES_CALCULATION,
      );

      return DecimalsService.truncateDoseOrQuantity(doseCalculated);
    }

    return Number((dose * area).toFixed(4));
  }

  function truncateDecimalPlaces(value) {
    return DecimalsService.truncate(value, DecimalsService.DECIMAL_PLACES_DOSE_QUANTIDADE);
  }

  this.capacidadeTanque = formatForInput(this.recomendacao.capacidadeTanque);

  this.init = function() {
    const tanque = toCapacidadeTanqueNumber(this.capacidadeTanque);
    if (tanque > 0) {
      this.applyCapacidadeTanque(false);
    } else {
      this.showDoseTable = false;
    }
  };

  this.closeModal = function() {
    $uibModalInstance.close();
  };

  this.formatCapacidadeTanqueDisplay = function() {
    const value = toCapacidadeTanqueNumber(this.capacidadeTanque);
    if (!isNaN(value)) {
      this.capacidadeTanque = formatForInput(truncateDecimalPlaces(value));
    }
  };

  this.isCapacidadeTanqueValida = function() {
    const value = toCapacidadeTanqueNumber(this.capacidadeTanque);
    return !isNaN(value) && value > 0;
  };

  this.applyCapacidadeTanque = function(forceRecalculate) {
    this.formatCapacidadeTanqueDisplay();
    const areaByTanque = toCapacidadeTanqueNumber(this.capacidadeTanque) / (this.recomendacao.vazao || 1);
    const areaFixed = getAreaFixed(this.recomendacao.glebas.areaTotal);

    this.abastecidas = areaFixed / areaByTanque;
    this.produtos = this.recomendacao.produtos.map((produto) => {
      const currentDoseByTanque = toNumber(produto.doseByTanque);
      const doseByTanque = currentDoseByTanque > 0 && !forceRecalculate ?
        currentDoseByTanque :
        getDoseByTanque(produto.dose, areaByTanque);

      const mapped = { ...produto, doseByTanque };
      this.formatDoseByTanqueDisplay(mapped);

      const hasOriginalTotal = Math.max(+produto.qtTotal, 0) > 0;
      if (!hasOriginalTotal) {
        this.recalculateValues(mapped);
      }
      return mapped;
    });
    this.showDoseTable = this.produtos.length > 0;
  };

  function calculateDose(doseByTanque, areaByTanque) {
    if (!DecimalsService.isDecimalV2Enabled()) {
      return doseByTanque / areaByTanque;
    }

    const dose = DecimalsService.roundForCalculation(
      doseByTanque / areaByTanque,
      DecimalsService.DECIMAL_PLACES_CALCULATION,
    );
    return DecimalsService.truncateDoseOrQuantity(dose);
  }

  function calculateQuantidadeTotal(dose, areaTotal) {
    if (!DecimalsService.isDecimalV2Enabled()) {
      return dose * areaTotal;
    }

    const quantidadeTotal = DecimalsService.roundForCalculation(
      dose * areaTotal,
      DecimalsService.DECIMAL_PLACES_CALCULATION,
    );
    return DecimalsService.truncateDoseOrQuantity(quantidadeTotal);
  }

  this.recalculateValues = function(produto) {
    const areaByTanque = toCapacidadeTanqueNumber(this.capacidadeTanque) / (this.recomendacao.vazao || 1);
    const areaFixed = getAreaFixed(this.recomendacao.glebas.areaTotal);
    const doseByTanque = toNumber(produto.doseByTanque) || 0;

    produto.dose = calculateDose(doseByTanque, areaByTanque);
    produto.qtTotal = calculateQuantidadeTotal(produto.dose, areaFixed);
  };

  const VALOR_MINIMO = 0.0001;

  this.isProdutoValido = function(produto) {
    const value = toNumber(produto.doseByTanque);
    return !isNaN(value) && value >= VALOR_MINIMO;
  };

  this.formatDoseByTanqueDisplay = function(produto) {
    const value = toNumber(produto.doseByTanque);
    if (!isNaN(value)) {
      produto.doseByTanque = formatForInput(truncateDecimalPlaces(value));
    }
  };

  this.isProdutoResultadoValido = function(produto) {
    return produto.dose >= VALOR_MINIMO && produto.qtTotal >= VALOR_MINIMO;
  };

  this.validaProdutos = function() {
    if (!this.produtos || this.produtos.length === 0) {
      return false;
    }
    return this.produtos.every(
      (produto) => this.isProdutoValido(produto) && this.isProdutoResultadoValido(produto)
    );
  };

  this.getMensagemErro = function(produto) {
    if (this.isProdutoValido(produto)) {
      return '';
    }
    const { doseByTanque } = produto;
    const isEmpty = doseByTanque === null || typeof doseByTanque === 'undefined' || doseByTanque === '';
    return isEmpty ? 'Campo obrigatório' : 'Dose inválida';
  };


  this.save = function() {
    this.recomendacao.produtos.forEach((recProduto, index) => {
      const match = this.produtos.find((produto) => produto.id === recProduto.id);
      if (match) {
        this.recomendacao.produtos[index] = { ...match, doseByTanque: toNumber(match.doseByTanque) };
      }
    });
    this.recomendacao.capacidadeTanque = toCapacidadeTanqueNumber(this.capacidadeTanque);

    $uibModalInstance.close(this.recomendacao);
  };

  this.init();
});
